import { mapActions } from 'vuex'
import Configuration from '@/agilis/util/Configuration'

export default {
  name: 'DataTableSearchMixin',

  props: {
    api: String,
    configuration: Object
  },

  data () {
    return {
      items: [],
      itemsCount: 0,
      searchTxt: '',
      searchTxtInput: '',
      loading: false
    }
  },

  watch: {
    options: {
      handler (val) {
        this.fetchData()

        this.dumpUserAction({
          itemsPerPage: val.itemsPerPage,
          sortBy: val.sortBy,
          sortDesc: val.sortDesc
        })
      },
      deep: true
    }
  },

  mounted: function () {
    this.fetchData()
  },

  computed: {
    searchViaSqlQuery () {
      return this.configuration.querySelectMode
    },

    searchApi () {
      if (this.searchViaSqlQuery) {
        if (this.dataTableConfiguration.querySelectModeApi) {
          return this.dataTableConfiguration.querySelectModeApi.url
        }

        return this.$axios.agilisUrlQuery(this.applicationId, this.dataTableConfiguration.querySelectMode)
      }
      return this.$axios.agilisUrlDataTableSearch(this.api) // standard flow
    }
  },

  methods: {
    ...mapActions({
      'notifyError': 'notificationStore/notifyError'
    }),

    fetchData () {
      this.loading = true
      const url = this.searchApi
      this.$axios
        .get(
          url,
          this.$axios.agilisRequestConfig(url))
        .then((response) => {
          this.items = response.data
          this.loading = false
        })
        .catch((error) => {
          this.notifyError(error)
          this.loading = false
        })
    },

    filterSearch (colValue, searchString, dataRow) {
      let found = false

      const searchFieldArray = this.dataTableConfiguration ? Configuration.datatable.getSearchFields(this.dataTableConfiguration) : []

      if (colValue && searchString) {
        for (let colId of searchFieldArray) {
          colValue = dataRow[colId]
          const colConfig = this.dataTableConfiguration.columns[colId]
          if (colConfig) {
            colValue = Configuration.datatable.renderColumn(colConfig, dataRow)
          }
          colValue = colValue ? colValue.toString().toUpperCase() : ''
          found = colValue.indexOf(searchString.toUpperCase()) !== -1
          if (found) {
            break
          }
        }
      }
      return found
    },

    handleSearchTxtInput (event) {
      if (event.keyCode === 13) {
        this.searchTxt = this.searchTxtInput
      }
    },

    handleSearchLensInput (event) {
      this.searchTxt = this.searchTxtInput
    }
  }
}
